const React = require("react");
const T = React.PropTypes;
const moment = require("moment");

require("./SurveyOverview.less");

const SurveyType = require("~/types/Survey.js").PropType;
const AuditTypes = require("~/config.js").AuditTypes;
const navigator = require("~/navigator.js");
const UploadURL = require("~/config.js").UploadURL;

const SurveyOverview = React.createClass({
    propTypes: {
        Survey: SurveyType.isRequired,
    },
    render() {
        const walkThruURL = `#walk-thru/${this.props.Survey.Type}/${this.props.Survey.FacilityNumber}/${this.props.Survey.GUID}`;

        const TaskListURL = `https://cuberepository.blob.core.windows.net/caudit-task-pdfs/TaskList_${this.props.Survey.GUID}.pdf`; 

        const auditType = AuditTypes[this.props.Survey.Type];

        const typeName = (auditType ? auditType.FriendlyName : "") || "Type unknown";

        const pct = this.props.Survey.MaxScore === 0
            ? 0
            : (this.props.Survey.Score / this.props.Survey.MaxScore * 100).toFixed(0);

        const attachments = this.GetAttachments();

        return (<div className="cs-SurveyOverview">
            <div className="cs-SurveyOverview__title">
                {`Store ${this.props.Survey.FacilityNumber} - ${typeName}`}
            </div>
            <div className="cs-SurveyOverview__title">
                {this.props.Survey.AuditPeriod}
            </div>
            <div className="cs-SurveyOverview__rows">
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Confirmation Number:</div>
                    <div className="cs-SectionOverview__row__cell">
                        {this.props.Survey.ConfirmationCode}
                    </div>
                </div>
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Audit Status:</div>
                    <div className="cs-SectionOverview__row__cell">Complete</div>
                </div>
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Audit Score:</div>
                    <div className="cs-SectionOverview__row__cell">
                        {this.props.Survey.Score}/{this.props.Survey.MaxScore} - {pct}%
                    </div>
                </div>
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Location:</div>
                    <div className="cs-SectionOverview__row__cell">
                        {`Store ${this.props.Survey.FacilityNumber}`}
                    </div>
                </div>
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Completed On:</div>
                    <div className="cs-SectionOverview__row__cell">
                        {moment(this.props.Survey.CompletedOn).format("M-D-YYYY")}
                    </div>
                </div>
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Submitted On:</div>
                    <div className="cs-SectionOverview__row__cell">
                        {moment(this.props.Survey.CompletedOn).format("M-D-YYYY")}
                    </div>
                </div>
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Most Recent Audit:</div>
                    <div className="cs-SectionOverview__row__cell">
                        {moment(this.props.Survey.MostRecentAudit).format("M-D-YYYY")}
                    </div>
                </div>
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Auditor:</div>
                    <div className="cs-SectionOverview__row__cell">
                        {this.props.Survey.CompletedBy}
                    </div>
                </div>
                {/*<div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Walk Thru List:</div>
                    <div className="cs-SectionOverview__row__cell">
                        <a href={walkThruURL} className="cs-SurveyOverview__link">
                            View Walk Thru
                        </a>
                    </div>
                </div>*/}
                {attachments}
                <div className="cs-SurveyOverview__row__upload-files">
                    <div className="cs-SurveyOverview__row__cell">&nbsp;</div>
                    <div className="cs-SectionOverview__row__cell">
                        <a href={UploadURL} className="cs-SurveyOverview__link" target="_blank">
                            Click here to upload files
                        </a>
                    </div>
                </div>
                <div className="cs-SurveyOverview__row">
                    <div className="cs-SurveyOverview__row__cell">Task List:</div>
                    <div className="cs-SectionOverview__row__cell">
                        <a href={TaskListURL}>
                            Download Task List 
                        </a>
                    </div>
                </div>
            </div>
        </div>);
    },
    GetAttachments() {
        if (!(this.props.Survey.Attachments || []).length) {
            return null;
        }

        const attachmentItems = this.props.Survey.Attachments.map((a, i) => {
            const url = navigator.GetLink.ToAttachment(a);

            return (<li key={i}>
                <a className="cs-SurveyOverview__link" href={url}>
                    {a.Name}
                </a>
            </li>);
        });

        return (<div className="cs-SurveyOverview__row">
            <div className="cs-SurveyOverview__row__cell">Attachments:</div>
            <div className="cs-SectionOverview__row__cell">
                <ul className="cs-SectionOverview__attachment-list">
                    {attachmentItems}
                </ul>
            </div>
        </div>);
    }
});

module.exports = SurveyOverview;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SurveyOverview/SurveyOverview.jsx